import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { GoogleCalTokenApi } from "../services/googleTokenApi";
import { Context } from "../App";

export default function GoogleOAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setCalendarToken } = React.useContext(Context);
  const [status, setStatus] = useState<string>("Processing...");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const error = searchParams.get("error");

      if (error) {
        setError(`OAuth error: ${error}`);
        setTimeout(() => navigate("/admin"), 3000);
        return;
      }

      if (!code) {
        setError("No authorization code received");
        setTimeout(() => navigate("/admin"), 3000);
        return;
      }

      try {
        setStatus("Exchanging authorization code...");

        const redirectUri = `${window.location.origin}/oauth/callback`;

        const api = new GoogleCalTokenApi();
        const result = await api.exchangeAuthCode({
          code,
          redirectUri,
        });

        setCalendarToken(result.accessToken);
        setStatus("Connected successfully! Redirecting...");

        setTimeout(() => navigate("/admin"), 1500);
      } catch (e: any) {
        setError(e?.message ?? "Failed to complete authentication");
        setTimeout(() => navigate("/admin"), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setCalendarToken]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Google Calendar Authentication</h2>
      {error ? (
        <div style={{ marginTop: "1rem", color: "crimson" }}>{error}</div>
      ) : (
        <div style={{ marginTop: "1rem" }}>{status}</div>
      )}
    </div>
  );
}
